var arabam;
(function (arabam) {
    function lastSearches() {
        return {
            restrict: 'EA',
            transclude: true,
            scope: {
                searchCallback: '&',
                deleteCallback: '&'
            },
            replace: true,
            templateUrl: 'lastSearches.html',
            controller: ["$scope", "LastSearchService", function ($scope, LastSearchService) {
                    var ls = this;
                    ls.searches = [];
                    ls.sessionId = "";
                    ls.init = function () {
                        var self = this;
                        /**
                         * algoritma
                         * servisten son aramalari al
                         * servisten suanki sessionidyi al
                         * son aramalarin icinde sessionid ayni olanlari (yani bu sessionda kaydedilenleri) filtrele (alma / kullanma)
                         */
                        self.searches = LastSearchService.getSearches();
                        self.sessionId = LastSearchService.getSessionId();
                        self.searches.map(function (item) {
                            item.filters = item.filters.filter(onlyUnique);
                        });
                        self.searches = self.searches.filter(function (search) {
                            return search.sessionId != self.sessionId;
                        });
                    };
                    function onlyUnique(value, index, self) {
                        return self.indexOf(value) === index;
                    }
                    ls.remove = function (item) {
                        var self = this;
                        LastSearchService.removeItem(item);
                        ls.init();
                        $scope.deleteCallback();
                    };
                    ls.search = function (item) {
                        var self = this;
                        $scope.searchCallback({ selectedFilters: item.selectedFilters, url: item.url });
                    };
                    ls.init();
                }],
            controllerAs: 'ls'
        };
    }
    angular
        .module('arabam')
        .directive('lastSearches', lastSearches);
})(arabam || (arabam = {}));
